import type { ApiConfig } from "@/services/api/client";
import { toast } from "@/composables/ui/useDialogs";

/**
 * Request config for panel section loads: no generic error popup (the interceptor would show the raw
 * API text, e.g. "Forbidden") and any non-2xx rejects so the section can show its own state.
 */
export const panelRequest: ApiConfig = {
  skipSwal: true,
  validateStatus: (status: number) => status >= 200 && status < 300,
};

/** True when a rejected panel request means the account lacks permission for the section. */
export function isForbidden(error: unknown): boolean {
  const status = (error as any)?.response?.status;
  return status === 403 || status === 401;
}

/** Non-permission failures still tell the user (the generic popup is skipped for panel loads). */
export function reportPanelError(context: string, error: unknown): void {
  console.error(context, error);
  const e = error as any;
  toast(String(e?.response?.data?.error || e?.message || context), "error", 4000);
}
